export function listFiles(value) {
  if (Array.isArray(value)) return value.filter(Boolean)
  return value ? [value] : []
}

export function serializeMetadata(metadata) {
  return JSON.stringify(
    (metadata || [])
      .filter((row) => row && String(row.id || '').trim() !== '')
      .map((row) => ({
        id: String(row.id).trim(),
        value: row.value != null ? row.value : '',
      }))
  )
}

export function normalizeMetadataRows(metadata) {
  return Array.isArray(metadata)
    ? metadata
        .map((row) => ({
          id: row && row.id != null ? String(row.id).trim() : '',
          field: row && row.field != null ? String(row.field) : '',
          value: row && row.value != null ? row.value : '',
        }))
        .filter((row) => row.id || row.field)
    : []
}

export function requiredFileRule(value) {
  if (Array.isArray(value)) {
    return value.length > 0 || 'File không thể bỏ trống'
  }
  return !!value || 'File không thể bỏ trống'
}
